import { useEffect, useSyncExternalStore } from "react";

/**
 * Tiny global signal that lets a page inside <Layout> suppress the platform
 * navbar + footer for the duration of its mount.
 *
 * Used by storefront-branded public pages (e.g. the guest offer page reached
 * from a courier's own storefront) so the visitor never sees EuroCollis
 * marketplace chrome wrapped around the courier's brand.
 */
let hidden = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}

export function useGlobalChromeHidden(): boolean {
  return useSyncExternalStore(subscribe, () => hidden > 0, () => false);
}

/** Hide the platform chrome while `active` is true. */
export function useHideGlobalChrome(active: boolean) {
  useEffect(() => {
    if (!active) return;
    hidden += 1;
    emit();
    return () => { hidden = Math.max(0, hidden - 1); emit(); };
  }, [active]);
}
